/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: E74QHYWzCoX_

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import ButtonBarItem from "../../ButtonBarItem"; // plasmic-import: -0BhGbCKruWI/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicButtonBar.module.css"; // plasmic-import: E74QHYWzCoX_/css

createPlasmicElementProxy;

export type PlasmicButtonBar__VariantMembers = {};
export type PlasmicButtonBar__VariantsArgs = {};
type VariantPropType = keyof PlasmicButtonBar__VariantsArgs;
export const PlasmicButtonBar__VariantProps = new Array<VariantPropType>();

export type PlasmicButtonBar__ArgsType = {
  options?: any;
  value?: string;
  onValueChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicButtonBar__ArgsType;
export const PlasmicButtonBar__ArgProps = new Array<ArgPropType>(
  "options",
  "value",
  "onValueChange"
);

export type PlasmicButtonBar__OverridesType = {
  wrapper?: Flex__<"div">;
  buttonBarItem?: Flex__<typeof ButtonBarItem>;
  text?: Flex__<"div">;
};

export interface DefaultButtonBarProps {
  options?: any;
  value?: string;
  onValueChange?: (val: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicButtonBar__RenderFunc(props: {
  variants: PlasmicButtonBar__VariantsArgs;
  args: PlasmicButtonBar__ArgsType;
  overrides: PlasmicButtonBar__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "value",
        type: "writable",
        variableType: "text",

        valueProp: "value",
        onChangeProp: "onValueChange"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"wrapper"}
      data-plasmic-override={overrides.wrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.wrapper
      )}
      role={"radiogroup"}
    >
      {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
        (() => {
          try {
            return $props.options;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return [];
            }
            throw e;
          }
        })()
      ).map((__plasmic_item_0, __plasmic_idx_0) => {
        const currentItem = __plasmic_item_0;
        const currentIndex = __plasmic_idx_0;
        return (
          <ButtonBarItem
            data-plasmic-name={"buttonBarItem"}
            data-plasmic-override={overrides.buttonBarItem}
            className={classNames("__wab_instance", sty.buttonBarItem)}
            key={currentIndex}
            onClick={async () => {
              const $steps = {};

              $steps["updateValue"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["value"]
                      },
                      operation: 0,
                      value: currentItem.value
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateValue"] != null &&
                typeof $steps["updateValue"] === "object" &&
                typeof $steps["updateValue"].then === "function"
              ) {
                $steps["updateValue"] = await $steps["updateValue"];
              }
            }}
            selected={(() => {
              try {
                return $state.value === currentItem.value;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            tooltip={(() => {
              try {
                return currentItem?.tooltip;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
          >
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text
              )}
            >
              <React.Fragment>{currentItem.label}</React.Fragment>
            </div>
          </ButtonBarItem>
        );
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  wrapper: ["wrapper", "buttonBarItem", "text"],
  buttonBarItem: ["buttonBarItem", "text"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  wrapper: "div";
  buttonBarItem: typeof ButtonBarItem;
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicButtonBar__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicButtonBar__VariantsArgs;
    args?: PlasmicButtonBar__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicButtonBar__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicButtonBar__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonBar__ArgProps,
          internalVariantPropNames: PlasmicButtonBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrapper") {
    func.displayName = "PlasmicButtonBar";
  } else {
    func.displayName = `PlasmicButtonBar.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonBar = Object.assign(
  // Top-level PlasmicButtonBar renders the root element
  makeNodeComponent("wrapper"),
  {
    // Helper components rendering sub-elements
    buttonBarItem: makeNodeComponent("buttonBarItem"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicButtonBar
    internalVariantProps: PlasmicButtonBar__VariantProps,
    internalArgProps: PlasmicButtonBar__ArgProps
  }
);

export default PlasmicButtonBar;
/* prettier-ignore-end */
